import { useGate, useUnit } from 'effector-react'
import {
  $blockedCount,
  $providerOptions,
  $typeOptions,
  GatewayBlocksLookupGate,
} from './model'

export const useGatewayBlocksBadge = (clientId: string) => {
  useGate(GatewayBlocksLookupGate, { clientId })

  return useUnit($blockedCount)
}

export const useGatewayFilterOptions = () => {
  const providerOptions = useUnit($providerOptions)
  const typeOptions = useUnit($typeOptions)

  return { providerOptions, typeOptions }
}
